/**
 * 服务端未绑定错误；其他错误保留服务端脱敏后的具体原因。
 */
export const AUTHORIZATION_NOT_BOUND = 1002000005

/**
 * 同时读取普通查询和 H5 hash 路由查询，授权码仅解码一次并保留等号。
 */
export function readAuthorizationCallback(value: string): { code: string; state: string; tenantId?: string } {
    const url = new URL(value)
    const queryIndex = url.hash.indexOf('?')
    const hashParams = new URLSearchParams(queryIndex < 0 ? '' : url.hash.slice(queryIndex + 1))
    return {
        code: url.searchParams.get('code') || hashParams.get('code') || '',
        state: url.searchParams.get('state') || hashParams.get('state') || '',
        tenantId: url.searchParams.get('tenantId') || hashParams.get('tenantId') || undefined
    }
}

export function authorizationErrorCode(error: unknown): number | undefined {
    if (!error || typeof error !== 'object') return undefined
    const code = Number((error as { code?: unknown }).code)
    return Number.isFinite(code) ? code : undefined
}

export function authorizationErrorMessage(error: unknown, fallback = '授权失败，请重新发起授权'): string {
    if (error && typeof error === 'object') {
        const value = error as { msg?: unknown; message?: unknown }
        if (typeof value.msg === 'string' && value.msg) return value.msg
        if (typeof value.message === 'string' && value.message) return value.message
    }
    return fallback
}
